<div class="order-history-list">
  @if (displaySearchFilters) {
  <div class="filters">
    <strong class="filter-label">Rechercher un achat</strong>

    <div class="filter-item">
      <label>Début</label>
      <div>
        <input type="date" [(ngModel)]="periodStart" class="casto-input" />
      </div>
    </div>

    <div class="filter-item">
      <label>Fin</label>
      <div>
        <input type="date" [(ngModel)]="periodEnd" class="casto-input" />
      </div>
    </div>

    <div class="filter-item">
      <div class="casto-input-group casto-input-group-abp-validation">
        <div>
          <input
            type="text"
            [(ngModel)]="ean"
            class="casto-input"
            placeholder="Saisir un EAN"
            (keyup.enter)="search()"
          />
        </div>
        <button type="button" (click)="search()" [disabled]="loading">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>

    <ng-casto-btn class="blue"
                  label="Vider les filtres"
                  (click)="clearFilters()"
                  [disabled]="loading"></ng-casto-btn>
  </div>
  }

  <p *ngIf="!loading && orderHistories?.totalCount > 0" class="filter-count">
    {{ orderHistories.totalCount }}
    {{ orderHistories.totalCount > 1 ? 'achats' : 'achat' }}
  </p>

  <!-- Loader -->
  <div class="text-center" *ngIf="loading">
    <ng-casto-loader></ng-casto-loader>
  </div>

  <!-- Résultats -->
  <ng-container *ngIf="!loading && orderHistories">
    <!-- Liste -->
    <ng-container *ngIf="orderHistories.totalCount > 0; else noData">
      @for (orderHistory of orderHistories.items; track orderHistory.orderIdAssociated) {
        <section class="order-history-card" (click)="openDetails(orderHistory)">
          <header>Castorama {{ orderHistory.storeNameAssociated }}</header>

          <section class="order-history-card-body">
            <p>
              Acheté le <strong>{{ orderHistory.activityDate | date: 'dd/MM/yyyy' }}</strong>
            </p>
            <p>
              Ticket N° <strong>{{ orderHistory.ticketNumberAssociated }}</strong>
            </p>
          </section>

          <footer>
            <p class="products-number">
              {{ orderHistory.nbProducts }}
              {{ orderHistory.nbProducts > 1 ? 'articles' : 'article' }}
            </p>
            <div class="total-price">{{ orderHistory.totalPrice | currency: 'EUR' }}</div>
          </footer>
        </section>
      }

      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[5, 10, 20]"
        (onPageChange)="onPageChange($event)"
      ></p-paginator>
    </ng-container>

    <ng-template #noData>
      <div class="text-center">
        <h2 class="m-3">Aucune donnée disponible</h2>
      </div>
    </ng-template>
  </ng-container>
</div>
